import { Box, Grid2 } from '@mui/material';
import { useEffect, useState } from 'react';
import { getStreamByEndpointAsync } from 'services/Events';
import { DEFENSE_EVENTS_ENDPOINT } from 'services/Defense/Events';
import CardLastEventDefense from 'pages/MonitoringPage/_components/CardLastEventDefense';
import { IDefenseEventSimpleProps } from 'services/Defense/Events/types';
import ShieldIcon from '@mui/icons-material/Shield';

const ScreenAllEvents = () => {
  const [events, setEvents] = useState<IDefenseEventSimpleProps[]>([]);

  useEffect(() => {
    getStreamByEndpointAsync(DEFENSE_EVENTS_ENDPOINT + '/last', setEvents);
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
        }}
      >
        <Grid2
          display={'grid'}
          sx={{
            width: '99%',
            height: '100%',
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              sm: 'repeat(3, 1fr)',
            },
            gap: 2,
          }}
        >
          {events.map((event, index) => (
            <CardLastEventDefense
              key={index}
              events={[event]}
              widthProps={'100%'}
              iconProp={<ShieldIcon />}
            />
          ))}
        </Grid2>
      </Box>
    </>
  );
};

export default ScreenAllEvents;
